"use client";

import Image from "next/image";
import React from "react";
const StatsCardHover = ({
  cardStyle,
  title,
  subtitle,
  icon,
  iconHover,
  iconStyle,
  gridStyle,
  wid,
  hei
}: {
  cardStyle?: any;
  title: string;
  subtitle: string;
  icon: string;
  iconHover?: string;
  iconStyle?: any;
  gridStyle: {
    gridRow: string;
    gridColumn: string;
  };
  wid?: number;
  hei?: number;
}) => {
  return <div className="stats-section-card--1" style={{
    ...gridStyle,
    ...cardStyle
  }} data-sentry-component="StatsCardHover" data-sentry-source-file="StatsCardHover.tsx">
      <div className="stats-section-card--1--text">
        <div className="stats-section-card--title">
          {title}
        </div>
        <div className="stats-section-card--subtitle">
          {subtitle}
        </div>
      </div>
      <div style={{
      position: "relative",
      width: `${wid}px`,
      height: `${hei}px`,
      alignSelf: "end"
    }}>
        <Image className="stats-section-card--1--image" src={icon} alt="icon" width={wid} height={hei} style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        ...iconStyle
      }} data-sentry-element="Image" data-sentry-source-file="StatsCardHover.tsx" />
        <Image className="stats-section-card--1--hover-image" src={iconHover || icon} alt="icon" width={wid} height={hei} style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        ...iconStyle
      }} data-sentry-element="Image" data-sentry-source-file="StatsCardHover.tsx" />
      </div>
    </div>;
};
export default StatsCardHover;